import { z } from 'zod';
import { InvoiceSchema } from './invoice.js';
import { BillSchema } from './bill.js';
export const EntityRecordSchema = z.object({
    PK: z.string(),
    SK: z.string(),
    'GSI-PK-1': z.string(),
    'GSI-SK-1': z.string(),
    lastUpdatedOn: z.string().optional(),
    createdOn: z.string().datetime(),
    createdBy: z.string(),
    entity: InvoiceSchema.or(BillSchema),
});
export const InvoiceRecordSchema = EntityRecordSchema.merge(z.object({
    entity: InvoiceSchema,
}));
export const isInvoiceRecord = (entity) => InvoiceRecordSchema.safeParse(entity).success;
export const BillRecordSchema = EntityRecordSchema.merge(z.object({
    entity: BillSchema,
}));
export const isBillRecord = (entity) => BillRecordSchema.safeParse(entity).success;
